module.exports = __webpack_public_path__ + "static/media/article1-image.f8d020d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article1-image.png
// module id = 358
// module chunks = 3